export default __webpack_public_path__ + "static/media/Group1489@2x.eb1bf8b2.png";